export default __webpack_public_path__ + "static/media/Pattern.657fb7b5.png";